module.exports = __webpack_public_path__ + "img/TSY_02_02.f35caeac.png";